import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UnconformityModel } from '../model/unconformity.model';

@Injectable()
export class UnconformityService {

	path = '/unconformity';

	constructor(private baseService: BaseService) { }

	getPaginated(init: number, end: number, description: string) {
		return this.baseService.get(this.path, '', { init, end, description });
	}

	post(unconformity: UnconformityModel) {
		return this.baseService.post(this.path, '/', unconformity);
	}

	put(unconformity: UnconformityModel) {
		return this.baseService.put(this.path, '/', unconformity);
	}

	delete(id: number) {
		return this.baseService.delete(this.path, '/' + id);
	}

	save(unconformity: UnconformityModel) {
		if (unconformity.id) { return this.put(unconformity); } else { return this.post(unconformity); }
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/unconformity.service.ts